export default {
    name: 'DataLayerHandler',
    data: () => ({
        lastMessage: {},
        sessionEvents: []
    }),
    computed: {
        dataLayer() {
            return window.dataLayer || []
        }
    },
    created() {
        if (!window.hasOwnProperty('dataLayer')) {
            window.dataLayer = window.dataLayer || [];
        }
    },
    watch: {
        lastMessage: {
            handler: function (nv, ov) {
                if (!!nv && Object.keys(nv).length && nv !== ov) {
                    let dl = window.dataLayer || []
                    dl.push(nv)
                    if (process.env.NODE_ENV == 'development') {
                        console.debug('dataLayer updated', nv)
                    }
                }

            },
            deep: true
        }
    },
    methods: {
        pushObject(o) {
            this.lastMessage = o
            this.sessionEvents.push({event: o.event, data: o.eventData})
        },
        addWithData(event, payload, once) {
            once = typeof once !== undefined? once:true
            if (once) {
                if (!this.sessionEvents.includes({event: event, data: payload})) {
                    this.pushObject({event: event, data: payload})
                } else {
                    console.log('event already tracked')
                }
            } else {
                this.pushObject({event: event, data: payload})
            }
        }
    },
    created() {
        this.$on('enrich', (v) => {
            this.addWithData(v.event, v.data, v.once || undefined)
        })
    }
}